import { AppBar, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import { ROUTES } from '../../constants/routes';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { logout } from '../../modules/reducer/authSlice';
import Footer from '../Footer';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import pellaLogo from '../../assets/pella_logo.png';
import { refreshDateFormatter } from '../../constants/utils';
import { SidebarMenu } from './SideBarMenu/sidebarMenu';

const Main = styled('main')(() => ({
  position: 'relative',
  marginLeft: 0,
  width: '85%',
  height: '100vh',
}));

const MainContent = styled('main')({
  background: grey[100],
  padding: '15px',
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  overflow: 'hidden',
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const Header = ({ component }) => {
  const { userData } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const performLogOut = () => {
    dispatch(logout());
    navigate(ROUTES.login);
  };

  const loggedInDisplayName = (_) => {
    const defaultNameToDisplay =
      userData?.data?.firstname?.length || userData?.data?.lastname?.length
        ? `${userData?.data?.firstname} ${userData?.data?.lastname}`
        : userData?.data?.username;
    if (userData?.data?.is_gale_admin || userData?.data?.user_role?.length === 0) {
      return defaultNameToDisplay;
    } else {
      return (
        userData?.data?.stores_data[0]?.branch_name ||
        (userData?.data?.email?.length && userData?.data?.email)
      );
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
        }}
      >
        <Toolbar>
          <Typography variant="body1" color="initial" sx={{ ml: 'auto' }}>
            Logged in as {loggedInDisplayName()}
          </Typography>
          <IconButton
            edge="end"
            aria-label="logout"
            aria-controls="logout"
            aria-haspopup="false"
            onClick={performLogOut}
            color="inherit"
            size="large"
          >
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: '15%',
          backgroundColor: 'black',
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 'inherit',
            boxSizing: 'border-box',
            backgroundColor: 'black',
            color: 'white',
            border: '0px',
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <DrawerHeader
          sx={{
            backgroundColor: '#ffde00',
            display: 'flex',
            justifyContent: 'space-between',
            borderColor: '#ffde00',
            width: '100%',
            height: 64,
          }}
        >
          <img src={pellaLogo} title="Pella Logo" alt="Pella Logo" height={'74px'} width={'74px'} />
        </DrawerHeader>
        <Divider />
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
          <div style={{ flex: 1 }}>
            {userData?.data?.menu?.length && <SidebarMenu menuData={userData?.data?.menu} />}
          </div>
          {!!userData?.data?.latest_refresh_date && (
            <div>
              <Typography variant="body2" fontStyle="italic" padding="0px 16px">
                Last refreshed on:
              </Typography>
              <Typography variant="body2" fontStyle="italic" padding="0px 16px">
                {refreshDateFormatter(userData?.data?.latest_refresh_date)}
              </Typography>
            </div>
          )}
        </div>
      </Drawer>
      <Main>
        <DrawerHeader style={{ marginTop: '10px', background: grey[100] }} />
        {
          <div
            style={{
              width: '100%',
              transition: 'width 0.3s ease-in-out',
            }}
          >
            <div>
              <MainContent>{component}</MainContent>
            </div>
            <Footer />
          </div>
        }
      </Main>
    </Box>
  );
};

export default Header;
